export enum Units {
    Foot = 0,
    Meter = 1,
    Kilometer = 2,
    Mile = 3
}
